import { writable } from 'svelte/store';

const STORAGE_KEY = 'sayano:reduced-motion';
const CHANGE_EVENT = 'sayano:reduced-motion';

export const reducedMotion = writable(false);

function inAppPreference(): boolean {
	return localStorage.getItem(STORAGE_KEY) === '1';
}

/**
 * Own the combined OS + in-app motion preference at the application root.
 * Components consume the store for JS-driven motion; CSS consumes the root
 * attribute, so neither layer has to duplicate the preference calculation.
 */
export function initReducedMotion(): () => void {
	if (typeof window === 'undefined') return () => {};

	const media = window.matchMedia('(prefers-reduced-motion: reduce)');
	const update = () => {
		const next = media.matches || inAppPreference();
		reducedMotion.set(next);
		document.documentElement.toggleAttribute('data-reduced-motion', next);
	};

	update();
	media.addEventListener('change', update);
	window.addEventListener('storage', update);
	window.addEventListener(CHANGE_EVENT, update);

	return () => {
		media.removeEventListener('change', update);
		window.removeEventListener('storage', update);
		window.removeEventListener(CHANGE_EVENT, update);
	};
}

/** Update the in-app override and notify the current document immediately. */
export function setReducedMotionPreference(enabled: boolean): void {
	if (typeof window === 'undefined') return;
	localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
	window.dispatchEvent(new Event(CHANGE_EVENT));
}
